// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1695) return "static/css/1695.d0bf0648fe9de4d4988e.css";
	if (chunkId === 7564) return "static/css/sender.d2fa50e600c8902170ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1412":"4f767f2564a62b1968c8","5514":"e6d0a1931c5aa48ac7ec","6877":"201f07b8e64160d7069f"}[chunkId] + ".chunk.css";
};